module.exports = __webpack_public_path__ + "media/10.1020ad83.mp3";